import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { APP_CONFIG_IN_ASSET } from './config.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class NgxTranslationService implements TranslateLoader {

  constructor(private http: HttpClient) {
  }

  getTranslation(lang: string): Observable<any> {
    return this.http.get(APP_CONFIG_IN_ASSET.rootConfig + APP_CONFIG_IN_ASSET.translationsFolder + lang + '.json?ts=' + new Date().getTime())
      .pipe(
        tap((response: any) => response)
      );
  }
}
